import { Icon } from "../../Icon";

export const feedbackResourceIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="nonzero" d="M32 5.333c14.704 0 26.667 11.963 26.667 26.667 0 14.704-11.963 26.667-26.667 26.667C17.296 58.667 5.333 46.704 5.333 32 5.333 17.296 17.296 5.333 32 5.333ZM32 0C14.328 0 0 14.328 0 32s14.328 32 32 32 32-14.328 32-32S49.672 0 32 0Zm-.855 41v-6.773h5.812v-2.965h-5.812v-4.418h6.246v-2.977h-9.82V41h3.574Z"/></svg>`
);
